import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
	beforeLoad: ({ context }) => {
		if (!context.auth.isLoaded) {
			return;
		}
		if (context.auth.isAuthenticated) {
			throw redirect({ to: '/shipments' });
		}
		throw redirect({ to: '/sign-in' });
	},
	component: () => null,
});
